<template>
  <el-container class="page_chili">
    <el-main style="height:1000px">
      <el-col :span="7" style="height:auto">
        <div>
          <span class="h4title">变压器列表</span>
        </div>
        <div class="tableTitle">
          <span class="midText"></span>
        </div>
        <div class="grid-content bg-purple" style="padding:10px;">
          <el-table
            @row-click="handdle"
            class="class"
    :row-style="{height: '40px'}"
            :data="tableData4"
            highlight-current-row
            stripe
            style="width: 100%;padding:5px;height:900px">
            <el-table-column  label="序号" type="index"  width="50"  align="center"></el-table-column>
            <el-table-column prop="TransformerName" label="变压器名称"></el-table-column>
            <el-table-column prop="RatedCapacity" label="额定容量(kVA)"></el-table-column>
            <el-table-column prop="AlarmLoad" label="告警负荷(KW)"></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="1" style="height:100%">
        <div class="verticalBar"></div>
      </el-col>
      <el-col :span="16">
        <div>
          <span class="h4title">变压器参数设置</span>
        </div>
        <div class="tableTitle">
          <span class="midText"></span>
        </div>
        <div class="grid-content bg-purple-light" style="padding:20px;background:#fff">
          <el-form
            class="demo-form-inline"
            ref="form"
            :model="sizeForm"
            label-width="50%"
            size="mini"
            style="font-size: 8px;padding:40px"
          >
            <el-row style="height:auto">
              <el-row :span="24">  </el-row>
              <el-col :span="8">
                <el-form-item label="设备名称">
                  <el-input v-model="sizeForm.TransformerName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="厂家品牌">
                  <el-input v-model="sizeForm.Manufactor"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分接位置">
                  <el-input v-model="sizeForm.TapPosition"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="连接组标号">
                  <el-input v-model="sizeForm.ConnectionGroupLabel"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="温升">
                  <el-input v-model="sizeForm.TemperatureRise"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="建立时间">
                  <el-input v-model="sizeForm.CreaTime" readonly="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="额定容量">
                  <el-input v-model="sizeForm.RatedCapacity"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="设备型号">
                  <el-input v-model="sizeForm.EquipmentModel"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="额定电U1">
                  <el-input v-model="sizeForm.RatedU1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="额定电U2">
                  <el-input v-model="sizeForm.RatedU2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="空载损耗">
                  <el-input v-model="sizeForm.Noloadloss"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="冷却方式">
                  <el-input v-model="sizeForm.CoolingMode"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="总重量">
                  <el-input v-model="sizeForm.TotalWeight"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="标准代号">
                  <el-input v-model="sizeForm.StandardCode"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="额定电流A1">
                  <el-input v-model="sizeForm.RatedA1"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="额定电流A2">
                  <el-input v-model="sizeForm.RatedA2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="负载损耗">
                  <el-input v-model="sizeForm.LoadLoss"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="绝缘水平">
                  <el-input v-model="sizeForm.InsulationLevel"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="告警负荷*">
                  <el-input v-model="sizeForm.AlarmLoad"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item class="demo-form-inline" label="三相电流不平衡">
                  <el-input v-model="sizeForm.ThreeA"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="三相电压不平衡*">
                  <el-input v-model="sizeForm.ThareeU"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="功率因数限值*">
                  <el-input v-model="sizeForm.PowerFactorlimit"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序值">
                  <el-input v-model="sizeForm.Sort"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="id" >
                  <el-input v-model="sizeForm.TransformerID"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item size="large">
              <el-button type="primary" @click="onSubmit(sizeForm)">保存</el-button>
              <el-button>取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-main>
  </el-container>
</template>
<script lang="ts">
import echarts from "echarts";
import request from "../../utils/request";
export default {
  mounted() {
    this.onGetDate();
  },
  methods: {
    onSubmit() {
      request({
        url: "MeterTrans/SubmitPage7Data",
        method: "post",
        data: this.sizeForm,
      }).then((response) => {
        alert("保存成功!");
      });
    },
    handdle(row) {
       var that = this;
       var strTransformerID = row.TransformerID;
       var  parmit = {
            TransformerID: strTransformerID
       }
      request({
        url: "MeterTrans/GetPage7GetRowInfo",
        method: "post",
        data: parmit,
      }).then((response) => {
        console.log("Page7rowINFO")
        console.log(response)
        that.sizeForm = response.data;
      });
    },
    onGetDate() {
      var that = this;
      request({
        url: "MeterTrans/GetPage7Data",
        method: "post",
        data: this.sizeForm,
      }).then((response) => {
        that.tableData4 = response.data.items;
      }) .catch(function (error) { // 请求失败处理
      });
    },
  },
  data() {
    return {
      sizeForm: [{
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
        TransformerID: "",
        TransformerName: "",
        Manufactor: "",
        TapPosition: "",
        ConnectionGroupLabel: "",
        TemperatureRise: "",
        CreaTime: "",
        RatedCapacity: "",
        EquipmentModel: "",
        RatedU1: "",
        RatedU2: "",
        Noloadloss: "",
        CoolingMode: "",
        TotalWeight: "",
        StandardCode: "",
        RatedA1: "",
        RatedA2: "",
        LoadLoss: "",
        InsulationLevel: "",
        AlarmLoad: "",
        ThreeA: "",
        ThareeU: "",
        PowerFactorlimit: "",
        Sort: "",
      }],
      tableData4: [],
    };
  },
};
</script>
<style scoped>
.tableTitle {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 1px;
  background-color: #d4d4d4;
  text-align: center;
  font-size: 16px;
  color: rgba(101, 101, 101, 1);
}
.midText {
  position: absolute;
  left: 50%;
  background-color: #ffffff;
  padding: 0 15px;
  transform: translateX(-50%) translateY(-50%);
}
.verticalBar {
  width: 1px;
  height: 100%;
  background: #d4d4d4;
  display: inline-block;
  margin-top: 31px;
  vertical-align: top;
  margin-right: 29px;
  margin-left: 30px;
}
.h4title {
  font-family: "微软雅黑";
  margin: 0;
  padding: 10px 0 0px 0;
  line-height: 30px;
  font-size: 17px;
  font-weight: bold;
  color: #09f;
}
</style>
<style>
/* 用来设置当前页面element全局table的内间距 */
.el-table__row td{
    padding: 0;
}
/* 用来设置当前页面element全局table 选中某行时的背景色*/
.el-table__body tr.current-row>td{
  background-color: #5c6282 !important;
 color: #f19944;   /* 设置文字颜色，可以选择不设置 */
}
/* 用来设置当前页面element全局table 鼠标移入某行时的背景色*/
.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #5c6282;
   color: #f19944;  /* 设置文字颜色，可以选择不设置 */
}
</style>